<script setup>
import axios from '/node_modules/axios';
import { ref } from '/node_modules/vue';
import ToolTip from './ToolTip.vue';
import { useStore } from 'vuex';
import { getStockMusicWireList, getStainlessWireList, updateQuote } from '../api/api';
import { reactive, watch, computed } from 'vue';
import { pushToDataLayer } from '@/api/gtm';


const store = useStore();

let messages = ref([])
let diameters = ref([]);

const specs = reactive({
    unitType: null,
    outerDiameter: null,
    materialType: null,
    wireDiameter: null,
    overallLength: null,
    SBC: null,
    endType: null,
    TQ1: null,
    TQ2: null,
    TQ3: null,
    TQ4: null
});

const gtmData = {
  'event' : 'Estimate'
}

watch(specs,  (newValue) => {
  store.commit('updateSpecs', newValue);
})

function updateDiameters() {
  if (specs.materialType.includes('Music')) {
    getStockMusicWireList().then((dia) => {
      if (store.state.specs.unitType == 'Metric (mm)') {
        for (let x = 0; x < dia.length; x++) {
          dia[x] = String((parseFloat(dia[x].trim()) * 25.4).toFixed(4));
          if (dia[x] == 'NaN') {
            dia[x] = '';
          }
      }
      }
      diameters.value = dia;
    });
  } else {
    getStainlessWireList().then((dia)=>{
      if (store.state.specs.unitType == 'Metric (mm)') {
        for (let x = 0; x < (dia.length - 1); x++) {
          dia[x] = String((parseFloat(dia[x].trim()) * 25.4).toFixed(4));
      }
      }
      diameters.value = dia;
    });
  }
}

function hasDiameters() {
  return diameters.value.length > 0;
}

function validateForm() {
  document.getElementById("results").scrollIntoView({behavior: 'smooth'});
  if (specsValid() == true) {
    store.commit('updating', true);
    updateQuote(store.state).then(()=>{
      if (store.state.quotes[0].total == 'NaN') {
        let error_quotes = []
        error_quotes.push({quantity: 'Price could not be calculated. Verify your spring details and submit again'})
        store.commit('updateQuotes', error_quotes);
      }
      store.commit('updating', false);
    });
  }
}

async function submitForm() {
  axios.post('http://wbjones-r00.loc/wp-json/custom-springs/v1/calculate/', {
    "UT": specs.unitType,
    "OD": specs.outerDiameter,
    "WD": specs.wireDiameter,
    "MN": specs.materialType,
    "OL": specs.overallLength,
    "SBC": specs.SBC,
    "ET": specs.endType,
    "TQ1": specs.TQ1,
    "TQ2": specs.TQ2,
    "TQ3": specs.TQ3,
    "TQ4": specs.TQ4
  }).then(function (response) {
    localStorage.setItem('post_id', JSON.stringify(response.data));
    axios.get('http://wbjones-r00.loc/wp-json/wp/v2/custom-springs/' + response.data).then(function (response2) {
      let loading = document.getElementById('loading-animation');
      loading.style.display = "none";
      loading.style.visbility = "hidden";
      let overlay = document.getElementById('overlay');
      overlay.style.right = 'unset';
      overlay.style.left = '0';
      if (window.screen.availWidth < 600) {
        for (let x = 0; x < 4; x++) {
          document.getElementById('quantity_' + x + '_price_mobile').innerHTML = '$' + (parseFloat(response2.data.acf['quantity_' + (x + 1) + '_price_per_unit'])).toFixed(2);
          document.getElementById('quantity_' + x + '_total_mobile').innerHTML = '$' + (parseFloat(response2.data.acf['quantity_' + (x + 1) + '_price_per_unit']) * parseFloat(response2.data.acf['test_quantity_' + (x + 1)])).toFixed(2);
          document.getElementById('quantity_' + x + '_quantity_mobile').innerHTML = (parseFloat(response2.data.acf['test_quantity_' + (x + 1)])).toFixed(2);
        }
      } else {
        for (let x = 0; x < 4; x++) {
          document.getElementById('quantity_' + x + '_price').innerHTML = '$' + (parseFloat(response2.data.acf['quantity_' + (x + 1) + '_price_per_unit'])).toFixed(2);
          document.getElementById('quantity_' + x + '_total').innerHTML = '$' + (parseFloat(response2.data.acf['quantity_' + (x + 1) + '_price_per_unit']) * parseFloat(response2.data.acf['test_quantity_' + (x + 1)])).toFixed(2);
          document.getElementById('quantity_' + x + '_quantity').innerHTML = (parseFloat(response2.data.acf['test_quantity_' + (x + 1)])).toFixed(2);
        }
      }
    });
  }).catch(function (error) {
    console.log(error)
  })
}

async function updateForm() {
      localStorage.setItem('formInputs', JSON.stringify({
        "UT": unitType['string'],
        "OD": outerDiameter,
        "WD": wireDiameter['string'],
        "MN": materialType['string'],
        "OL": overallLength,
        "SBC": SBC,
        "ET": endType['string'],
        "TQ1": TQ1,
        "TQ2": TQ2,
        "TQ3": TQ3,
        "TQ4": TQ4
      }));
      axios.post(`http://wbjones-r00.loc/wp-json/custom-springs/v1/calculate/${localStorage.getItem('post_id')}`, {
        "UT": unitType['string'],
        "OD": outerDiameter,
        "WD": wireDiameter,
        "MN": materialType['string'],
        "OL": overallLength,
        "SBC": SBC,
        "ET": endType['string'],
        "TQ1": TQ1,
        "TQ2": TQ2,
        "TQ3": TQ3,
        "TQ4": TQ4,
        "id" : localStorage.getItem('post_id')
      }).then(function (response) {

        // localStorage.setItem('post_id', JSON.stringify(response.data));
       axios.get('http://wbjones-r00.loc/wp-json/wp/v2/custom-springs/' + localStorage.getItem('post_id')).then(function (response2) {
        let loading = document.getElementById('loading-animation');
    loading.style.display = "none";
    loading.style.visbility = "hidden";
        let overlay = document.getElementById('overlay');
        overlay.style.right = 'unset';
        overlay.style.left = '0';
        if (window.screen.availWidth < 600) {
          for (let x = 0; x < 4; x++) {
            document.getElementById('quantity_' + x + '_price_mobile').innerHTML = '$' + (parseFloat(response2.data.acf['quantity_' + (x + 1) + '_price_per_unit'])).toFixed(2);
            document.getElementById('quantity_' + x + '_total_mobile').innerHTML = '$' + (parseFloat(response2.data.acf['quantity_' + (x + 1) + '_price_per_unit']) * parseFloat(response2.data.acf['test_quantity_' + (x + 1)])).toFixed(2);
            document.getElementById('quantity_' + x + '_quantity_mobile').innerHTML = (parseFloat(response2.data.acf['test_quantity_' + (x + 1)])).toFixed(2);
          }
        } else {
          for (let x = 0; x < 4; x++) {
            document.getElementById('quantity_' + x + '_price').innerHTML = '$' + (parseFloat(response2.data.acf['quantity_' + (x + 1) + '_price_per_unit'])).toFixed(2);
            document.getElementById('quantity_' + x + '_total').innerHTML = '$' + (parseFloat(response2.data.acf['quantity_' + (x + 1) + '_price_per_unit']) * parseFloat(response2.data.acf['test_quantity_' + (x + 1)])).toFixed(2);
            document.getElementById('quantity_' + x + '_quantity').innerHTML = (parseFloat(response2.data.acf['test_quantity_' + (x + 1)])).toFixed(2);
          }
        }

       });
      }).catch(function (error){
        console.log(error)
      })
}

function validateQty(event) {
  
  if (Number(event.target.value) > 1000) {
    event.target.setCustomValidity("Max quantity is 1000");
    event.target.reportValidity();
    event.target.classList.add('invalid');
    
  } else {
    event.target.setCustomValidity("");
    event.target.reportValidity();
  }
}

function validateInput(input) {
  if (input.value == '') {return}
  input.checkValidity();
  input.setCustomValidity('');
  let valid = input.checkValidity();
  if (!valid) {
    input.classList.add("invalid");
    input.setCustomValidity(input.getAttribute('err-message'));
    input.reportValidity();
  } else {
    input.classList.remove("invalid");
  }
}

function specsValid() {
  return store.getters.specsValid;
}

function clearInputs() {
  Object.assign(specs, {
    unitType: specs.unitType,
    outerDiameter: null,
    materialType: specs.materialType,
    wireDiameter: null,
    overallLength: null,
    SBC: null,
    endType: specs.endType,
    TQ1: null,
    TQ2: null,
    TQ3: null,
    TQ4: null
})
}
</script>

<template> 
  <div id="estimate-form" class="pb-3 px-1">
    <div class="estimate-form-overlay" ref="overlay" id="overlay" :style="{display: store.state.quotes.length ? 'block':'none'}"></div>
    
      <h2 class="w-100 text-lg-center font-weight-bold" id="details">Enter Your Spring Details</h2>

      <div class="border-bottom w-100 mb-3"></div>
      
      <div  class="invalid-message" style="display:none;visibility:hidden;height:100%;background-color: rgba(255,0,0,.5);width:100%">
        <ul>
          <li v-for="(message, index) in messages" :key="index">
            <p>{{ message }}</p>
          </li>
        </ul>
      </div>

      <form novalidate="novalidate" class="d-block w-100">
        <!-- Units -->
        <div class="d-flex flex-column flex-lg-row col-12 my-4">
          <label for="unitType" class="col-lg-6 col-form-label text-lg-right my-auto">Unit Type</label>
          <div class="col-lg-6">
            <select 
                required
                @change="(event) => {validateInput(event.target); updateDiameters(); clearInputs()}"
                v-model="specs.unitType" 
                class="form-control w-75 d-inline" 
                id="unitType"
                err-message="Please select a Unit Type">
                <option disabled value="">Select</option>
                <option value="English (in)">English (in)</option>
                <option value="Metric (mm)">Metric (mm)</option>
              </select>
              <ToolTip class="d-inline"
              content="View the <a style='color:white;border-bottom:1px solid white;text-decoration:none;font-weight:600' target='_blank' href='/products/compression-springs/guide-to-measuring-compression-springs/'>measuring guide</a> for more detail"
            />
          </div>
        </div>

        

        <!-- Material Type -->
        <div class="d-flex flex-column flex-lg-row col-12 my-4">
            <label for="materialType" class="col-lg-6 col-form-label text-lg-right my-auto">Material Type</label>
            <div class="col-lg-6">
              <select 
                v-model="specs.materialType" 
                @change="updateDiameters()" 
                required
                @focusout="(event) => validateInput(event.target)"
                class="form-control w-75 d-inline" 
                id="materialType"
                err-message="Please select a Material Type">
                <option value="" disabled>Select</option>
                <option value="Music Wire - Plain Finish">Music Wire - Plain Finish</option>
                <option value="Music Wire - Zinc Finish">Music Wire - Zinc Finish</option>
                <option value="Stainless 302 - Plain Finish">Stainless 302 - Plain Finish</option>
                <option value="Stainless 302 - Passivated">Stainless 302 - Passivated</option>
              </select>
            <ToolTip class="d-inline"
              content="Music wire (ASTM A 228): General-purpose carbon that provides high strength and a good surface finish. Add zinc for increased corrosion resistance. <br></br> Stainless 302 (ASTM A 313): General-purpose stainless that offers corrosion and heat resistance up to 500˚F. Add passivation for increased corrosion resistance."
            />
          </div>
          
        </div>

        <!-- Wire Diameter -->
        <div class="d-flex flex-column flex-lg-row col-12 my-4">
          <label for="wireDiameter" class="col-lg-6 col-form-label text-lg-right my-auto">Wire Diameter</label>
          <div class="d-flex align-items-center col-lg-6">
            <select 
              v-model="specs.wireDiameter" 
              class="form-control w-50" 
              required
              id="wireDiameter"  
              v-if="hasDiameters()">
              <option value="">Select a diameter</option>
              <option  v-for="(diameter, index) in diameters" :key="index" :value="diameter.trim()" >{{ diameter }}</option>
            </select>
            <select 
              v-model="specs.wireDiameter" 
              class="form-control w-50"  
              id="wireDiameter" disabled v-else>
              <option :value="''" disabled >Please Select a Material Type to Continue</option>
            </select>
            <ToolTip class="d-inline"
              content="View the <a style='color:white;border-bottom:1px solid white;text-decoration:none;font-weight:600' target='_blank' href='/products/compression-springs/guide-to-measuring-compression-springs/'>measuring guide</a> for more detail"
            />
          </div>
        </div>

        <!-- Outer Diameter -->
        <div class="d-flex flex-column flex-lg-row col-12 my-4">
          <label for="outerDiameter" class="col-lg-6 col-form-label text-lg-right my-auto">Outer Diameter</label>
          <div class="d-flex align-items-center col-lg-6">
            <input 
            type="number"
              v-model="specs.outerDiameter" 
              class="form-control w-50" 
              @input="(event) => validateInput(event.target)"
              required
              step="0.0001"
              :min="store.state.specs.unitType == 'English (in)' ? 0.088 : 2.2352"
              :max="store.state.specs.unitType == 'English (in)' ? 3.750 : 95.25"
              :err-message="store.state.specs.unitType == 'English (in)' ? 'Outer Diameter should be a number between 0.088 and 3.750' : 'Outer Diameter should be a number between 2.2352 and 95.25'"
              id="outerDiameter">
              <ToolTip class="d-inline"
              content="View the <a style='color:white;border-bottom:1px solid white;text-decoration:none;font-weight:600' target='_blank' href='/products/compression-springs/guide-to-measuring-compression-springs/'>measuring guide</a> for more detail"
            />
          </div>
        </div>

        <!-- Overall Length -->
        <div class="d-flex flex-column flex-lg-row col-12 my-4">
          <label for="overallLength" class="col-lg-6 text-lg-right my-auto">Free Length</label>
          <div class="d-flex align-items-center col-lg-6">
            <input 
              v-model="specs.overallLength" 
              required
              @focusout="(event)=>validateInput(event.target)"
              class="form-control w-50" 
              id="overallLength"
              min="0"
              step="0.001"
              type="number"
              :max="store.state.specs.unitType == 'English (in)' ? 72 : 1828.8"
              :err-message="store.state.specs.unitType == 'English (in)' ?  'Free Length should be greater than or equal to 0 and less than 72' : 'Free Length should be greater than or equal to 0 and less than 1828.8' ">
              <ToolTip class="d-inline"
              content="View the <a style='color:white;border-bottom:1px solid white;text-decoration:none;font-weight:600' target='_blank' href='/products/compression-springs/guide-to-measuring-compression-springs/'>measuring guide</a> for more detail"
            />
          </div>
        </div>

        <!-- Space between coils -->
        <div class="d-flex flex-column flex-lg-row col-12 my-4">
          <label for="SBC" class="col-lg-6 text-lg-right my-auto">Space Between Coils</label>
          <div class="d-flex align-items-center col-lg-6">
            <input 
              type="number"
              v-model="specs.SBC" 
              class="form-control w-50"
              required
              @focusout="(event)=>validateInput(event.target)" 
              id="SBC"
              min="0.0"
              step="0.0001"
              err-message="Space Between Coils should be greater than 0">
              <ToolTip class="d-inline"
              content="View the <a style='color:white;border-bottom:1px solid white;text-decoration:none;font-weight:600' target='_blank' href='/products/compression-springs/guide-to-measuring-compression-springs/'>measuring guide</a> for more detail"
            />
          </div>
        </div>

        <!-- End Type -->
        <div class="d-flex flex-column flex-lg-row col-12 my-4">
            <label for="endType" class="col-lg-6 text-lg-right my-auto">End Type</label>
            <div class="d-flex align-items-center col-lg-6">
              <select 
                v-model="specs.endType"  
                @focusout="(event)=>validateInput(event.target)"
                required
                class="form-control w-75  d-inline" 
                id="endType"
              err-message="Please select an End Type">
                <!-- <option :value="null" selected hidden>Select End Type</option> -->
                <option value="Closed Not Ground">Closed Not Ground</option>
                <option value="Closed And Ground" >Closed And Ground</option>
                <option value="Open Not Ground" >Open Not Ground</option>
                <option value="Open And Ground" >Open And Ground</option>
              </select>
              <ToolTip class="d-inline"
                content='Watch <a style="color:white;border-bottom:1px solid white;text-decoration:none;font-weight:600" target="_blank" href="https://www.youtube.com/watch?v=5Ki8BNICRBY">Video</a> for more detail'
              />
            </div>
        </div>

        <!-- Quantities-->
        <div class="d-flex flex-column flex-lg-row col-12 my-4 quantities">
          <label for="tq1" class="col-lg-6 text-lg-right my-auto">Enter up to four quantities.</label>
          <div class="col-lg-6">
            <input 
              id="tq1"
              type="number" 
              v-model="specs.TQ1" 
              @input="(event) => validateQty(event)" 
              class="form-control"
              max="1000">
            <input type="number" v-model="specs.TQ2" @input="(event) => validateQty(event)" class="form-control" max="1000">
            <input type="number" v-model="specs.TQ3" @input="(event) => validateQty(event)" class="form-control" max="1000">
            <input type="number" v-model="specs.TQ4" @input="(event) => validateQty(event)" class="form-control" max="1000">
          </div>
        </div>

        <div class="border-bottom w-100 my-3"></div>

        
        <div class=" d-flex w-100 my-3 row ms-lg-3 ms-lg-0 me-lg-auto ml-md-0 ml-1 justify-content-md-end justify-content-start">
          <div >
          <button @click.prevent="() => {pushToDataLayer(gtmData); validateForm()}" 
            class="form-control btn btn-outline-secondary w-auto px-3 mx-lg-auto" 
            :disabled="!specsValid()">CALCULATE</button>
          </div>
        </div>
        
      </form>
      
      
    </div> 
  
</template>
 

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#estimate-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  width: 100%;
  position: relative;
  @media screen and (max-width: 576px) {
    margin-bottom:3rem;
  }



  h2 {
    color: #1C5296;
    font-size:1.375rem;
  }

  label {
    font-weight:600;
    //margin-right: 1rem;
  }

  input, select {
    
    font-family: 'Open Sans' !important;
    //width: 200px;
    &.invalid {
      border: 3px solid red;
    }
    
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .quantities {
    input {
      margin-right:.25rem;
      width:23%;
      display: inline;
    }
  }

  .estimate-form-overlay { 
    position: absolute;
    background-color: rgba(299, 299, 299, .8);
    z-index: 999;
    position: absolute;
    left:0;
    top:0;
    right:0;
    bottom:0;
  }

  
  
}

// input.invalid, select.invalid {
//   border: 1px solid red;
// }

// input.quantities::-webkit-outer-spin-button, 
// input.quantities::-webkit-inner-spin-button, 
// input[type=number]::-webkit-outer-spin-button,
// input[type=number]::-webkit-inner-spin-button
//  {
//   /* Chrome, Safari, Edge, Opera */
//   -webkit-appearance: none;
//   margin: 0;
// }

// /* Firefox */
// input.quantities[type=number], input[type=number] {
//   -moz-appearance: textfield;
// }



// .material-type, .end-type {
//   padding-left:26px;
// }

// .divider {
//   height:1px;
//   width:100%;
//   border-bottom:1px solid #D8D8D8;
//   margin-top:5px;
//   margin-bottom:35px
// }
// .flex-end {
//   display:flex;
//   align-items:center;
//   justify-content: end;
//   width:100%
// }

// .submit-button {
//   width: 150px;
//   color: #44961C;
//   border-color: #44961C !important;
//   border-radius: 2px;
//   text-transform: uppercase;
//   font-weight: bold;
// }
// .submit-button:disabled {
//   color:grey;
//   border-color: grey !important;
// }

// .form-control {
//   border-color: #979797;
//   appearance: menulist;
// }

// h2 {
//   font-size:22px;
//   color:#1C5296;
//   font-weight:700
// }
// label {
//   text-align: right;
//   font-family: 'Open Sans';
//   font-weight: 700;
//   margin-right: 15px;
//   width: 150px;
// }
// .spacer {
//   height: 10px;
//   width: 100%;
// }






// /* input:invalid {
//   border-color: red !important;
// } */



// .form-field {
//   width: 150px;
//   height: 20px;
//   font-family: 'Open Sans';
//   font-size: 15px;
//   margin: 10px;
// }

// h3 {
//   margin: 40px 0 0;
// }
// ul {
//   list-style-type: none;
//   padding: 0;
// }
// li {
//   display: inline-block;
//   margin: 0 10px;
// }
// a {
//   color: #42b983;
// }

// @media (max-width: 550px) {

  
//   .flex-center {
//     flex-wrap: wrap;
//     justify-content: start !important;
//   }
  
  
   
  
  

  
// } 

// @media (max-width: 1000px) {
//   .input {
//     width: 125px !important;
//   }
// }
</style>
